module.exports = __webpack_public_path__ + "resources/icon_32_delete_active.1810cf76ebd70dcb.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_32_delete_active.png
// module id = 448
// module chunks = 0 1 2 3 4